import { useMemo } from 'react';
import { Navigate, Outlet as OutletUntyped } from 'react-router';

import {
  AuthorizedOutletContext,
  usePathParams,
  NewWsStoreProvider,
} from '@/true-fsd/data/advertiser-account';
import { useActiveUser } from '@/true-fsd/data/advertiser-account/react-query';
import { usePathParamsEntitiesById } from '@/true-fsd/data/advertiser-account/react-query';
import { isAuthenticated } from '@/true-fsd/data/isAuthenticated';

const AuthorizedOutlet = ({
  context,
}: {
  context: AuthorizedOutletContext;
}) => <OutletUntyped context={context} />;

export const AuthorizedContext = () => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  return <Authenticated />;
};

const Authenticated = () => {
  const ids = usePathParams() ?? {};

  const activeUser = useActiveUser();
  const {
    newAccountChannelRequest,
    account,
    workspace,
    channelRequest,
    ordData,
    permission,
    subscription,
    owner,
  } = usePathParamsEntitiesById(ids);

  const context = useMemo(() => {
    return {
      activeUser,
      activeNewAccountChannelRequest: newAccountChannelRequest,
      activeAccount: account,
      activeWorkspace: workspace,
      activeChannelRequest: channelRequest,
      ordData,
      permission,
      subscription,
      owner,
    };
  }, [
    activeUser,
    newAccountChannelRequest,
    account,
    workspace,
    channelRequest,
    ordData,
    permission,
    subscription,
    owner,
  ]);

  // console.log({ ids, context });

  return (
    <NewWsStoreProvider>
      <AuthorizedOutlet context={context} />
    </NewWsStoreProvider>
  );
};
